import { FC } from 'react'

import { NodeViewProps } from '@tiptap/react'

import { useMedia } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { FileListItem } from '../../../common/components/FileListItem.js'
import { T } from '../../../i18n/components/T.js'
import { Attachment } from '../../@types/index.js'
import { Container } from '../Container.js'

export const AttachmentNodeView: FC<NodeViewProps> = props => {
  const { node, deleteNode, getPos, editor } = props
  const initialData = node.attrs.attachment as Attachment
  const attachmentId = initialData?.id || (node.attrs.id as string)

  const { data: media } = useMedia({
    variables: {
      id: attachmentId,
    },
    fields: {
      onFile: 'basic',
    },
    useQueryOptions: {
      initialData,
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!attachmentId,
    },
  })

  if (!media && !attachmentId) {
    return (
      <Container {...props}>
        <T
          id="Generics.SomethingWentWrong"
          defaultMessage="Something went wrong"
        />
      </Container>
    )
  }
  const attachment = media as Attachment

  const onRemove = () => {
    const position = getPos() - 2
    const { url } = attachment
    deleteNode()
    editor
      .chain()
      .focus(position)
      .insertLink({ href: url })
      .insertContent(' ')
      .run()
  }

  return (
    <Container {...props}>
      <FileListItem
        name={attachment?.name}
        extension={attachment?.extension}
        size={attachment?.size}
        action={
          <div className="flex items-center space-s-3">
            {attachment?.isLoading ? (
              <SvgIcon className="animate-spin w-7 h-7" name="spinner" />
            ) : (
              <Tooltip>
                <Tooltip.Trigger>
                  <SvgIcon
                    onClick={onRemove}
                    className="text-content-subdued hover:text-content-hovered cursor-pointer w-6 h-6"
                    name="close"
                  />
                </Tooltip.Trigger>
                <Tooltip.Panel>
                  <T id="Generics.Delete" defaultMessage="Delete" />
                </Tooltip.Panel>
              </Tooltip>
            )}
          </div>
        }
      />
    </Container>
  )
}
